/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, inject, OnDestroy, OnInit } from "@angular/core";
import { ButtonModule } from 'primeng/button';
import { Router, RouterOutlet } from "@angular/router";
import { ZIndexUtils } from "primeng/utils";
import { CommonModule } from "@angular/common";
import { RoutedOutletService } from '@irian-ro/navigation-module';

@Component({
  selector: 'well-route-popup',
  templateUrl: './route-popup.component.html',
  styleUrls: ['./route-popup.component.scss'],
  standalone: true,
  imports: [ButtonModule, CommonModule, RouterOutlet]
})
export class RoutePopupComponent implements OnInit, OnDestroy {
  private routedOutletService = inject(RoutedOutletService);

  constructor(private router: Router, private elementRef: ElementRef) { }

  public close(): void {
    this.router.navigate([{ outlets: { popup: null } }]);
  }

  ngOnInit(): void {
    ZIndexUtils.set('modal', this.elementRef.nativeElement, 1000);
  }

  ngOnDestroy(): void {
    this.routedOutletService.resolve('popup');
  }
}
